import { DataClientOptions } from "~/modules/dataClient";

export const getDefaultDataClientOptions = (): DataClientOptions => ({
    connectToDevTools: false
});
